export type ShouldPrefillAddressFromItsInput = {
  hasHallVenue: boolean;
  hasStoredAddress: boolean;
};

export type ShouldPrefillHostFieldFromItsInput = {
  hostItsChanged: boolean;
  currentValue: unknown;
};

export type ShouldClearAddressOnHostItsChangeInput = {
  hasHallVenue: boolean;
  hasStoredAddress: boolean;
};

export function isNonEmptyTrimmedString(value: unknown): boolean {
  if (value == null) return false;
  return String(value).trim().length > 0;
}

/**
 * Whether ITS lookup may set the address field.
 * Allowed on initial load and after host change when neither hall venue nor stored override applies.
 */
export function shouldPrefillAddressFromIts(input: ShouldPrefillAddressFromItsInput): boolean {
  if (input.hasHallVenue || input.hasStoredAddress) return false;
  return true;
}

/** Whether ITS lookup may set hostName or mobileNo (refresh on host change or when empty). */
export function shouldPrefillHostFieldFromIts(input: ShouldPrefillHostFieldFromItsInput): boolean {
  if (input.hostItsChanged) return true;
  return !isNonEmptyTrimmedString(input.currentValue);
}

/** Whether host ITS change should clear the address field before the next lookup. */
export function shouldClearAddressOnHostItsChange(
  input: ShouldClearAddressOnHostItsChangeInput
): boolean {
  return !input.hasHallVenue && !input.hasStoredAddress;
}
